/**
 * Make a class name for end-to-end testing
 * @param {string} feature
 * @param {string} component
 * @param {string} ns
 * @return {`selenium-app-${string}-${string}`}
 */
export const endToEndTest = (feature: string, component: string, ns = "app") =>
  `selenium-${ns}-${feature}-${component}`;
